import type { ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Delete booking document by ID.
 *
 * @endpoint DELETE /api/saas/me/bookings/{bookingId}/documents/{documentId}
 * @scope saas
 * @see https://flecto.dev/api-5091109
 */
export async function deleteBookingDocument(
  bookingId: ParameterID,
  documentId: ParameterID
): Promise<void> {
  await api.delete(`/api/saas/me/bookings/${bookingId}/documents/${documentId}`)
}
